import React from 'react';
import axios from 'axios';
import {
  FaBell,
  FaUserMd,
  FaBookMedical,
  FaClipboardCheck,
  FaCalendarCheck,
  FaInfoCircle
} from 'react-icons/fa';

export default function NotificationsList({ notifications, setNotifications }) {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  const toggleReadStatus = async (notif) => {
    try {
      if (notif.isRead) {
        await axios.post(
          `${apiUrl}/api/notifications/${notif.id}/unread`,
          {},
          { withCredentials: true }
        );
        setNotifications((prev) =>
          prev.map((n) =>
            n.id === notif.id
              ? { ...n, isRead: false }
              : n
          )
        );
      } else {
        await axios.post(
          `${apiUrl}/api/notifications/${notif.id}/read`,
          {},
          { withCredentials: true }
        );
        setNotifications((prev) =>
          prev.map((n) =>
            n.id === notif.id
              ? { ...n, isRead: true }
              : n
          )
        );
      }
    } catch (err) {
      console.error(`Error toggling read status for ${notif.id}:`, err);
    }
  };

  if (!Array.isArray(notifications) || notifications.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-8 bg-white rounded-lg shadow-sm border border-gray-100">
        <FaBell className="text-4xl text-gray-300 mb-3" />
        <p className="text-gray-500 font-medium">No notifications</p>
      </div>
    );
  }

  const getNotificationContent = (notif) => {
    const { type, payload, createdAt } = notif;
    if (type === 'courseAssigned') {
      const course = Array.isArray(payload.courses) && payload.courses.length > 0 ? payload.courses[0].title : '';
      return (
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <FaBookMedical className="text-blue-500" />
            <span className="font-semibold text-blue-900">Assigned: {course}</span>
          </div>
          {payload.teacherUsername && (
            <div className="flex items-center gap-2 text-gray-700">
              <FaUserMd className="text-blue-400" />
              <span>{payload.teacherUsername}</span>
            </div>
          )}
          <div className="flex items-center gap-2 text-xs text-gray-400 mt-1">
            <FaCalendarCheck />
            <span>{createdAt}</span>
          </div>
        </div>
      );
    }
    if (type === 'studentReportSubmitted') {
      return (
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <FaClipboardCheck className="text-green-500" />
            <span className="font-semibold text-green-900">Report: {payload.courseName}</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700">
            <FaUserMd className="text-green-400" />
            <span>{payload.studentName}</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-gray-400 mt-1">
            <FaCalendarCheck />
            <span>{createdAt}</span>
          </div>
        </div>
      );
    }
    // fallback for unknown types
    return (
      <div className="flex items-center gap-2 text-gray-700">
        <FaInfoCircle className="text-gray-400" />
        <span>Notification</span>
        <span className="text-xs text-gray-400 ml-2">{createdAt}</span>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 px-6 py-4">
        <h2 className="text-white text-lg font-semibold flex items-center">
          <FaBell className="mr-2" />
          Notifications Center
        </h2>
      </div>
      <div className="divide-y divide-gray-100">
        {notifications.map((notif) => (
          <div
            key={notif.id}
            onClick={() => toggleReadStatus(notif)}
            className={`p-4 transition-all duration-200 cursor-pointer hover:bg-gray-50 ${
              notif.isRead ? 'bg-white' : 'bg-blue-50'
            }`}
          >
            {getNotificationContent(notif)}
          </div>
        ))}
      </div>
    </div>
  );
}
